import { Slides } from '@ui/banner/slides.tsx';
import { useBanners } from '../../entites/banners';
import { IBanner } from '@shared/types.ts';
import { LazyImage } from '@ui/common/lazy-image.tsx';
// import { Link } from '@heroui/react';

export const MainPromotion = () => {
  const { data, isPreloader, array } = useBanners();
  if (isPreloader) {
    return (
      <Slides isDisabled items={array}>
        <LazyImage />
      </Slides>
    );
  }
  return (
    <>
      <div className="lg:hidden">
        <Slides<IBanner> items={data}>
          {(item) => (
            <LazyImage src={item.image_web} />
            // <Link href={item?.link ?? '/'}>
            //   <LazyImage src={item.image_web} />
            // </Link>
          )}
        </Slides>
      </div>

      <div className="hidden lg:block container max-w-7xl lg:mx-auto">
        <Slides<IBanner> items={data} size="lg">
          {(item) => <LazyImage src={item.image_web} />}
        </Slides>
      </div>
    </>
  );
};
